import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import moment from 'moment';

import { getWeekDays, getWeekRange, showMsg } from '../../services/library';
import {
  STORAGE_EDITTRACKER_ISPENDING,
  STORAGE_EDITTRACKER_ISQUEUESELECTEDFILTER
} from '../../constants/storageConst';
import CommonService from '../../services/commonService';

const REQ_ET = 'edittracker/';
const isPendingFilter = +window.sessionStorage.getItem(STORAGE_EDITTRACKER_ISPENDING) || 0;
const isQueueSelectedFilter = +window.sessionStorage.getItem(STORAGE_EDITTRACKER_ISQUEUESELECTEDFILTER) || '';

export const fetchPublishedImageYTDReq = createAsyncThunk(
  `${REQ_ET}fetchPublishedImageYTDReq`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await CommonService.getPublishedImageYTD();
      if (response.status) {
        return response?.data?.[0] ?? {};
      } else {
        showMsg(response?.errors, 'error');
        return rejectWithValue(response?.errors);
      }
    } catch (error) {
      showMsg(error, 'error');
      return rejectWithValue(error);
    }
  }
);

const editTrakerSlice = createSlice({
  name: 'editTraker',
  initialState: {
    startDate: moment().toDate(),
    selectedDays: getWeekDays(getWeekRange(moment().toDate()).from),
    editTrackerData: [],
    editTrackerAllData: [],
    totals: [],
    totalCount: 0,
    totalCompleted: 0,
    published: 0,
    publishedYearToDate: 0,
    isEditTrackerLoader: false,
    // isUseQueueModal: false,
    isPublishedCountLoader: true,
    isBarchartLoader: false,
    isEnablePublishPhotoCount: false,
    isDownloadExcel: false,
    isPending: isPendingFilter,
    isQueueFilterSelected: isQueueSelectedFilter,
    deadlineLoadingId: 0,
    keyForXls: {},
    barChartData: [],
    selectedDate: new Date()
  },
  reducers: {
    setStartDate: {
      reducer(state, action) {
        state.startDate = action.payload;
      },
      prepare(payload) {
        return { payload };
      }
    },
    setEnablePublishPhotoCount: {
      reducer(state, action) {
        state.isEnablePublishPhotoCount = action.payload;
      },
      prepare(payload) {
        return { payload };
      }
    },
    setIsDownloadExcel: {
      reducer(state, action) {
        state.isDownloadExcel = action.payload;
      },
      prepare(payload) {
        return { payload };
      }
    },
    setSelectedDays: {
      reducer(state, action) {
        state.selectedDays = action.payload;
      },
      prepare(payload) {
        return { payload };
      }
    },
    setEditTrackerData: {
      reducer(state, action) {
        state.editTrackerData = action.payload;
      },
      prepare(payload) {
        return { payload };
      }
    },
    setTotals: {
      reducer(state, action) {
        state.totals = action.payload;
      },
      prepare(payload) {
        return { payload };
      }
    },
    setTotalCount: {
      reducer(state, action) {
        state.totalCount = action.payload;
      },
      prepare(payload) {
        return { payload };
      }
    },
    setTotalCompleted: {
      reducer(state, action) {
        state.totalCompleted = action.payload;
      },
      prepare(payload) {
        return { payload };
      }
    },
    setPublished: {
      reducer(state, action) {
        state.published = action.payload;
      },
      prepare(payload) {
        return { payload };
      }
    },
    setIsEditTrackerLoaded: {
      reducer(state, action) {
        state.isEditTrackerLoader = action.payload;
      },
      prepare(payload) {
        return { payload };
      }
    },
    // setIsUseQueueModal: {
    //   reducer(state, action) {
    //     state.isUseQueueModal = action.payload;
    //   },
    //   prepare(payload) {
    //     return { payload };
    //   }
    // },
    setBarchartLoaded: {
      reducer(state, action) {
        state.isBarchartLoader = action.payload;
      },
      prepare(payload) {
        return { payload };
      }
    },
    setIsPending: {
      reducer(state, action) {
        const value = +action.payload;
        window.sessionStorage.setItem(STORAGE_EDITTRACKER_ISPENDING, value);
        state.isPending = value;
      },
      prepare(payload) {
        return { payload };
      }
    },
    setIsQueueFilterSelected: {
      reducer(state, action) {
        const value = action.payload;
        window.sessionStorage.setItem(STORAGE_EDITTRACKER_ISQUEUESELECTEDFILTER, value);
        state.isQueueFilterSelected = value;
      },
      prepare(payload) {
        return { payload };
      }
    },
    setDeadlineLoadingId: {
      reducer(state, action) {
        state.deadlineLoadingId = action.payload;
      },
      prepare(payload) {
        return { payload };
      }
    },
    setKeyForXls: {
      reducer(state, action) {
        state.keyForXls = action.payload;
      },
      prepare(payload) {
        return { payload };
      }
    },
    setBarChartData: {
      reducer(state, action) {
        state.barChartData = action.payload;
      },
      prepare(payload) {
        return { payload };
      }
    },
    setSelectedDate: {
      reducer(state, action) {
        state.selectedDate = action.payload;
      },
      prepare(payload) {
        return { payload };
      }
    },
    setEditTrackerAllData: {
      reducer(state, action) {
        state.editTrackerAllData = action.payload;
      },
      prepare(payload) {
        return { payload };
      }
    }
  },
  extraReducers: builder => {
    builder
      //#region fetchPublishedImageYTDReq
      .addCase(fetchPublishedImageYTDReq.pending, state => {
        state.publishedYearToDate = 0;
        state.isPublishedCountLoader = true;
      })
      .addCase(fetchPublishedImageYTDReq.fulfilled, (state, action) => {
        const data = action.payload;
        state.publishedYearToDate = data ? data?.publishedYTDData || 0 : 0;
        state.isPublishedCountLoader = false;
      })
      .addCase(fetchPublishedImageYTDReq.rejected, state => {
        state.publishedYearToDate = 0;
        state.isPublishedCountLoader = false;
      });
    // #endregion
  }
});

export const {
  setStartDate,
  setSelectedDays,
  setEditTrackerData,
  setEditTrackerAllData,
  setTotals,
  setTotalCount,
  setTotalCompleted,
  setPublished,
  setIsEditTrackerLoaded,
  setBarchartLoaded,
  setIsPending,
  setIsQueueFilterSelected,
  setDeadlineLoadingId,
  setKeyForXls,
  setBarChartData,
  setSelectedDate,
  setEnablePublishPhotoCount,
  setIsDownloadExcel
  // setIsUseQueueModal
} = editTrakerSlice.actions;
export default editTrakerSlice.reducer;
